var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesignation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.00743879 6.39991L0.00891201 4.8C0.00891201 3.91995 0.800021 3.19995 1.77785 3.19995H4.80007V1.59789C4.80007 0.715303 5.50937 0 6.3985 0H9.60154C10.4844 0 11.2 0.71664 11.2 1.59789V3.19995H14.2222C15.2 3.19995 16 3.91995 16 4.8V6.39991H0.00743879ZM0.00596558 7.99995H15.9999V14.4001C15.9999 15.28 15.2 16 14.2221 16H1.77778C0.799954 16 0 15.28 0 14.4001L0.00596558 7.99995ZM6.39991 1.59984V3.19989H9.6V1.59984H6.39991ZM6.39991 7.99995V9.6H9.6V7.99995H6.39991Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignation);
export default __webpack_public_path__ + "static/media/designation.6dfa33a8577110b48c5e7e6a87a2745b.svg";
export { ForwardRef as ReactComponent };